import { render } from "./DynamicContentsModal.vue?vue&type=template&id=ca5d5f82&scoped=true"
import script from "./DynamicContentsModal.vue?vue&type=script&lang=js"
export * from "./DynamicContentsModal.vue?vue&type=script&lang=js"

import "./DynamicContentsModal.vue?vue&type=style&index=0&id=ca5d5f82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5d5f82"]])

export default __exports__